export const EventTypes = {
  // Common
  SIGN_IN_STARTED: { category: 'sign_in', name: 'started' },
  SIGN_IN_OAUTH_STARTED: { category: 'sign_in_oauth', name: 'started' },
  SIGN_IN_COMPLETED: { category: 'sign_in', name: 'completed' },

  // Web
  WEBSITE_VISITED: { category: 'website', name: 'visited' },
  WEBSITE_UNIVERSITY_HOW_TO_ACCEPT_CLICKED: {
    category: 'website_university_how_to_accept',
    name: 'clicked'
  },
  WEBSITE_SCORE_COMPARISON_ASSET_DOWNLOADED: {
    category: 'website_score_comparison_asset',
    name: 'downloaded'
  },
  WEBSITE_SAMPLE_CERTIFICATE_ASSET_DOWNLOADED: {
    category: 'website_sample_certificate_asset',
    name: 'downloaded'
  },
  WEBSITE_PURCHASE_TRY_FROM_RESTRICTED_COUNTRY_CLICKED: {
    category: 'purchase_try_from_restricted_country',
    name: 'clicked'
  },
  BLOCKED_USER_TRY_LOGIN: { category: 'blocked_user_try_login', name: 'started' },
  BLOCKED_USER_FOLLOWS_FAQ: { category: 'blocked_user_follows_faq', name: 'clicked' },

  APPLICATION_DOWNLOADED: { category: 'application', name: 'downloaded' },
  SIGN_UP_STARTED: { category: 'sign_up', name: 'started' },
  SIGN_UP_OAUTH_STARTED: { category: 'sign_up_oauth', name: 'started' },
  SIGN_UP_COMPLETED: { category: 'sign_up', name: 'completed' },

  // Web ECOMMERCE
  ECOMMERCE_DASHBOARD_BUY_BUTTON: { category: 'ecommerce_dashboard_buy_button', name: 'clicked' },
  ECOMMERCE_LANDING_PAGE_BUY_BUTTON: {
    category: 'ecommerce_landing_page_buy_button',
    name: 'clicked'
  },
  ECOMMERCE_CART_CHECKOUT_PROCEED: { category: 'ecommerce_cart_checkout_proceed', name: 'clicked' },
  ECOMMERCE_CART_COUPON_APPLIED: { category: 'ecommerce_cart_coupon_applied', name: 'clicked' },
  ECOMMERCE_ORDER_CONFIRMATION_RETURN_HOME: {
    category: 'ecommerce_order_confirmation_return_home',
    name: 'clicked'
  },
  ECOMMERCE_PURCHASE_COUNTRY_BLOCKED: {
    category: 'ecommerce_purchase_country_blocked',
    name: 'viewed'
  },

  // VPN Blocking
  USING_VPN_BLOCKED: { category: 'using_vpn', name: 'blocked' },

  // Web PURCHASE - dataLayer
  PURCHASE: 'purchase',

  // Id verification flow during test setup
  ID_IMAGE_FRONT_QUALITY_VERIFICATION_FAILED: {
    category: 'id_image_front_quality_verification',
    name: 'failed'
  },
  ID_IMAGE_FRONT_QUALITY_VERIFICATION_SUCCESS: {
    category: 'id_image_front_quality_verification',
    name: 'success'
  },
  ID_IMAGE_BACK_QUALITY_VERIFICATION_FAILED: {
    category: 'id_image_back_quality_verification',
    name: 'failed'
  },
  ID_IMAGE_BACK_QUALITY_VERIFICATION_SUCCESS: {
    category: 'id_image_back_quality_verification',
    name: 'success'
  },

  ID_VERIFICATION_STARTED: { category: 'id_verification', name: 'started' },
  ID_VERIFICATION_SUCCESS: { category: 'id_verification', name: 'success' },
  ID_VERIFICATION_FAILED: { category: 'id_verification', name: 'failed' },

  ROOM_SCAN_STARTED: { category: 'room_scan', name: 'started' },
  ROOM_SCAN_COMPLETED: { category: 'room_scan', name: 'completed' },
  ROOM_SCAN_ERROR: { category: 'room_scan', name: 'incomplete' },

  // Manual id verification flow
  ID_IMAGE_FRONT_QUALITY_MANUAL_VERIFICATION_FAILED: {
    category: 'id_image_front_quality_manual_verification',
    name: 'failed'
  },
  ID_IMAGE_FRONT_QUALITY_MANUAL_VERIFICATION_SUCCESS: {
    category: 'id_image_front_quality_manual_verification',
    name: 'success'
  },
  ID_IMAGE_BACK_QUALITY_MANUAL_VERIFICATION_FAILED: {
    category: 'id_image_back_quality_manual_verification',
    name: 'failed'
  },
  ID_IMAGE_BACK_QUALITY_MANUAL_VERIFICATION_SUCCESS: {
    category: 'id_image_back_quality_manual_verification',
    name: 'success'
  },

  MANUAL_ID_VERIFICATION_SUCCESS: { category: 'manual_id_verification', name: 'success' },
  MANUAL_ID_VERIFICATION_FAILED: { category: 'manual_id_verification', name: 'failed' },

  // Desktop
  APPLICATION_LAUNCHED: { category: 'application', name: 'launched' },

  // Desktop - Practice Test
  TEST_PRACTICE_LAUNCHED: { category: 'test_practice', name: 'launched' },
  TEST_PRACTICE_STARTED: { category: 'test_practice', name: 'started' },
  TEST_PRACTICE_RULES_ACCEPTED: { category: 'test_practice_rules', name: 'accepted' },
  TEST_PRACTICE_SETUP_STARTED: { category: 'test_practice_setup', name: 'started' },
  TEST_PRACTICE_SETUP_COMPLETED: { category: 'test_practice_setup', name: 'completed' },
  TEST_PRACTICE_SETUP_DROPPED: { category: 'test_practice_setup', name: 'dropped' },
  TEST_PRACTICE_HANGUP: { category: 'test_practice', name: 'hangup' },
  TEST_PRACTICE_ABORTED: { category: 'test_practice', name: 'aborted' },
  TEST_PRACTICE_FINISHED: { category: 'test_practice', name: 'finished' },
  TEST_PRACTICE_RESULTS_VIEWED: { category: 'test_practice_results', name: 'viewed' },

  // Desktop - Test
  TEST_LAUNCHED: { category: 'test', name: 'launched' },
  TEST_STARTED: { category: 'test', name: 'started' },
  TEST_RULES_ACCEPTED: { category: 'test_rules', name: 'accepted' },
  TEST_SETUP_STARTED: { category: 'test_setup', name: 'started' },
  TEST_SETUP_COMPLETED: { category: 'test_setup', name: 'completed' },
  TEST_SETUP_DROPPED: { category: 'test_setup', name: 'dropped' },
  TEST_HANGUP: { category: 'test', name: 'hangup' },
  TEST_ABORTED: { category: 'test', name: 'aborted' },
  TEST_FINISHED: { category: 'test', name: 'finished' },
  TEST_RESULTS_VIEWED: { category: 'test_results', name: 'viewed' },

  // Desktop - Test Setup
  TEST_SETUP_BANDWIDTH_SUCCESS: { category: 'test_setup_check_bandwidth', name: 'success' },
  TEST_SETUP_BANDWIDTH_FAILED: { category: 'test_setup_check_bandwidth', name: 'failed' },
  TEST_SETUP_SYSTEM_CHECK_SUCCESS: { category: 'test_setup_check_system', name: 'success' },
  TEST_SETUP_SYSTEM_CHECK_FAILED: { category: 'test_setup_check_system', name: 'failed' },
  TEST_SETUP_MICROPHONE_CHECK_SUCCESS: { category: 'test_setup_check_microphone', name: 'success' },
  TEST_SETUP_MICROPHONE_CHECK_FAILED: { category: 'test_setup_check_microphone', name: 'failed' },
  TEST_SETUP_BACKGROUND_NOISE_CHECK_SUCCESS: {
    category: 'test_setup_check_background_noise',
    name: 'success'
  },
  TEST_SETUP_BACKGROUND_NOISE_CHECK_FAILED: {
    category: 'test_setup_check_background_noise',
    name: 'failed'
  },
  TEST_SETUP_SPEAKER_CHECK_SUCCESS: {
    category: 'test_setup_check_audio_playback',
    name: 'success'
  },
  TEST_SETUP_SPEAKER_CHECK_FAILED: { category: 'test_setup_check_audio_playback', name: 'failed' },
  TEST_SETUP_TAKE_SELFIE_SUCCESS: { category: 'test_setup_take_a_selfie', name: 'success' },
  TEST_SETUP_TAKE_SELFIE_FAILED: { category: 'test_setup_take_a_selfie', name: 'failed' },
  TEST_SETUP_CAPTURE_VIDEO_SUCCESS: { category: 'test_setup_capture_video', name: 'success' },
  TEST_SETUP_CAPTURE_VIDEO_FAILED: { category: 'test_setup_capture_video', name: 'failed' },
  TEST_SETUP_ID_VERIFICATION_SUCCESS: { category: 'test_setup_id_verification', name: 'success' },
  TEST_SETUP_ID_VERIFICATION_FAILED: { category: 'test_setup_id_verification', name: 'failed' },
  VIDEO_SETUP_COMPLETED: { category: 'video_setup', name: 'completed' },

  // Desktop & Web - 2nd camera flow
  TEST_SETUP_2CAMERA_STARTED: { category: 'test_setup_check_2camera', name: 'started' },
  TEST_SETUP_2CAMERA_COMPLETED: { category: 'test_setup_check_2camera', name: 'completed' },
  TEST_SETUP_MOBILE_CAMERA_ACCESS_SUCCESS: {
    category: 'test_setup_check_mobile_camera_access',
    name: 'success'
  },
  TEST_SETUP_MOBILE_CAMERA_ACCESS_FAILED: {
    category: 'test_setup_check_mobile_camera_access',
    name: 'failed'
  },
  TEST_SETUP_QR_FAILED: { category: 'test_setup_check_QR', name: 'failed' },
  TEST_SETUP_2CAMERA_SKIPPED: { category: 'test_setup_check_2camera', name: 'skipped' },
  /**
   * Desktop — 2nd camera connection lifecycle.
   * Fired from useSecondCameraAutoRefreshImage hook.
   * Payloads: CONNECTION_TIMEOUT (none), FIRST_FRAME_RECEIVED (none),
   * S3_ERRORS_DISCONNECTION (none), SAME_IMAGE_DISCONNECTION (none).
   */
  TEST_SETUP_2CAMERA_CONNECTION_TIMEOUT: {
    category: 'test_setup_check_2camera',
    name: 'connection_timeout'
  },
  TEST_SETUP_2CAMERA_FIRST_FRAME_RECEIVED: {
    category: 'test_setup_check_2camera',
    name: 'first_frame_received'
  },
  TEST_SETUP_2CAMERA_S3_ERRORS_DISCONNECTION: {
    category: 'test_setup_check_2camera',
    name: 's3_errors_disconnection'
  },
  TEST_SETUP_2CAMERA_SAME_IMAGE_DISCONNECTION: {
    category: 'test_setup_check_2camera',
    name: 'same_image_disconnection'
  },

  /** Desktop — QR code generated. Payload: { proctoringSessionId } */
  QR_GENERATED: { category: 'test_setup_qr', name: 'generated' },

  /**
   * Mobile web — session lifecycle.
   * Payload: { browserInfo } (async, includes camera permission status).
   */
  MOBILE_SESSION_STARTED: { category: 'mobile_session', name: 'started' },

  /**
   * Mobile web — camera permission results.
   * Payload: { browserInfo }.
   */
  MOBILE_PERMISSIONS_GRANTED: { category: 'mobile_permissions', name: 'granted' },
  MOBILE_PERMISSIONS_DENIED: { category: 'mobile_permissions', name: 'denied' },

  /**
   * Mobile web — 2nd camera stream state.
   * STREAM_STARTED: { browserInfo }
   * STREAM_DROPPED: { reason, previousState, browserInfo }
   * RECONNECT_ATTEMPT: { attemptNumber, elapsedMs }
   */
  SECOND_CAMERA_STREAM_STARTED: { category: 'second_camera_stream', name: 'started' },
  SECOND_CAMERA_STREAM_DROPPED: { category: 'second_camera_stream', name: 'dropped' },
  SECOND_CAMERA_RECONNECT_ATTEMPT: { category: 'second_camera_stream', name: 'reconnect_attempt' },

  /**
   * Mobile web — camera initialization and frame upload lifecycle.
   * CAMERA_INITIALIZED: { proctoringSessionId, browserInfo }
   * FIRST_FRAME_UPLOADED: { elapsedMsSinceInit, browserInfo }
   * FRAME_UPLOAD_FAILED: { errorName, errorMessage, consecutiveFailures, browserInfo }
   * CAMERA_ERROR: { errorName, errorType, browserInfo }
   * SSE_RECONNECT_FAILED: { browserInfo }
   */
  MOBILE_CAMERA_INITIALIZED: { category: 'mobile_camera', name: 'initialized' },
  MOBILE_FIRST_FRAME_UPLOADED: { category: 'mobile_camera', name: 'first_frame_uploaded' },
  MOBILE_FRAME_UPLOAD_FAILED: { category: 'mobile_camera', name: 'frame_upload_failed' },
  MOBILE_CAMERA_ERROR: { category: 'mobile_camera', name: 'error' },
  MOBILE_SSE_RECONNECT_FAILED: { category: 'mobile_camera', name: 'sse_reconnect_failed' },

  /**
   * Mobile web — browser lifecycle (only emitted during active session).
   * VISIBILITY_CHANGE: { visibilityState, browserInfo }
   * ORIENTATION_CHANGE: { orientationType, orientationAngle, browserInfo }
   */
  MOBILE_VISIBILITY_CHANGE: { category: 'mobile_browser', name: 'visibility_change' },
  MOBILE_ORIENTATION_CHANGE: { category: 'mobile_browser', name: 'orientation_change' },

  /**
   * Mobile web — ID verification capture & upload lifecycle.
   * All payloads include { flow: 'legacy' | 'regula' }.
   * CAPTURED: + { photoSide } (legacy only)
   * UPLOAD_STARTED: + { photoSide } (legacy only)
   * UPLOAD_COMPLETED: + { photoSide } (legacy only)
   * UPLOAD_FAILED: + { reason } (legacy) or { code, reason } (regula)
   */
  ID_PHOTO_CAPTURED: { category: 'id_photo', name: 'captured' },
  ID_PHOTO_UPLOAD_STARTED: { category: 'id_photo_upload', name: 'started' },
  ID_PHOTO_UPLOAD_COMPLETED: { category: 'id_photo_upload', name: 'completed' },
  ID_PHOTO_UPLOAD_FAILED: { category: 'id_photo_upload', name: 'failed' },
  ID_PHOTO_UPLOAD_VRM_AVAILABLE: { category: 'id_photo_upload_service_vrm', name: 'available' },
  ID_PHOTO_UPLOAD_IDV_AVAILABLE: { category: 'id_photo_upload_service_idv', name: 'available' },
  ID_PHOTO_UPLOAD_VRM_UNAVAILABLE: { category: 'id_photo_upload_service_vrm', name: 'unavailable' },
  ID_PHOTO_UPLOAD_IDV_UNAVAILABLE: { category: 'id_photo_upload_service_idv', name: 'unavailable' },

  // Desktop - Exit Setup Feedback
  PRE_TEST_PRACTICE_EXITSETUP_FEEDBACK_SUBMITTED: {
    category: 'pre_test_practice_exitsetup_feedback',
    name: 'submitted'
  },
  PRE_TEST_ACTUAL_EXITSETUP_FEEDBACK_SUBMITTED: {
    category: 'pre_test_actual_exitsetup_feedback',
    name: 'submitted'
  },

  // Desktop - Feedback
  POST_TEST_PRACTICE_FEEDBACK_SUBMITTED: {
    category: 'post_test_practice_feedback',
    name: 'submitted'
  },
  POST_TEST_ACTUAL_FEEDBACK_SUBMITTED: { category: 'post_test_actual_feedback', name: 'submitted' }
};

export function asEventName(eventOrName: string | { category?: string; name: string }) {
  if (typeof eventOrName === 'string') {
    return eventOrName;
  }

  return [eventOrName.category, eventOrName.name].filter((value) => !!value).join('_');
}
